"use client";

import { NavItem, type NavItemConfig } from "./NavItem";
import { useMegaMenu } from "./MegaMenuContext";

interface MainNavProps {
  items?: NavItemConfig[];
}

export function MainNav({ items }: MainNavProps) {
  const { setActiveDropdown } = useMegaMenu();

  if (!items || items.length === 0) return null;

  return (
    <nav
      className="hidden xl:flex xl:items-center xl:justify-center xl:gap-4 3xl:gap-7 transition-all duration-300"
      onMouseLeave={() => setActiveDropdown(null)}
    >
      {items.map((item) => (
        <NavItem key={item.id} item={item} />
      ))}
    </nav>
  );
}